import { colors } from './colors'

export interface IHeader {
  backgroundColor: string
}

export const header: IHeader = {
  backgroundColor: colors.white,
}
